import React, { useEffect, useState } from 'react';
import './Introduction.css';
import { useLanguage } from '../contexts/LanguageContext';

const Introduction = () => {
  const { t } = useLanguage();
  useEffect(() => {
    const importCss = async () => {
      try {
        await import('./Introduction.css');//replacing the css with the css of the gallery of the suites
      } catch (err) {}
    };
    importCss();
  }, []);
  return (
    <div className="introduction-container">
      <div className="introduction-content">
        <h1 className="introduction-header">
          {t('introduction.header')}
        </h1>
        <p className="introduction-text">
          {t('introduction.text')}
        </p>
        {/* <a href="#welcome" className="introduction-button">
          הזמנת סוויטה
        </a> */}
      </div>
    </div>
  );
};

export default Introduction;
